import { MAPPING_ATYPE } from '../catalog/mapping';
import { RCU_TOP_TYPE } from '../catalog/protocol';
import { REDACTED } from './settings';
import type { RcuDocument } from '../wire';

/**
 * Credentials never reach a screen.
 *
 * A `wificonfig` mapping carries a Wi-Fi password in clear text, and the console
 * shows the exact document it sent. So the document is redacted once, where the
 * event is created, and nothing downstream can print it by accident. The feed is
 * history: nothing here is re-sent, so redaction costs no function.
 */
export const redactDocument = (document: RcuDocument): RcuDocument => {
  if (document.type !== RCU_TOP_TYPE.ADD_MAPPING) return document;

  return {
    ...document,
    data: document.data.map((entry) =>
      entry.atype === MAPPING_ATYPE.WIFI_CONFIG ? { ...entry, password: REDACTED } : entry,
    ),
  };
};
